/**
 * ChatAdapter - Clase base abstracta para adaptadores de chat
 *
 * Esta clase define la interfaz común que deben implementar todos los
 * adaptadores de chat (Firebase, gRPC, etc.)
 */
export class ChatAdapter {
  // SENDER TYPES - Tipos de remitentes
  AS_PASSENGER = 0;
  AS_DRIVER = 1;
  AS_PICAP = 2;
  AS_SHOPPER = 3;

  // DEFAULT MESSAGES
  DEFAULT_CONFIRM_MESSAGE = 'Hola! Estas recibiendo un servicio de mensajería corporativa de Picap , sigue las instrucciones de la app y si tienes dudas estaremos pendientes de ti en la linea telefónica.';

  /**
   * Inicializa la conexión con el servicio de chat
   * @returns {any} Instancia de conexión inicializada
   */
  initialize() {
    throw new Error('Method "initialize" must be implemented by subclass');
  }

  /**
   * Envía un mensaje al chat
   * @param {string} message - Contenido del mensaje
   * @param {number} senderType - Tipo de remitente (AS_PASSENGER, AS_DRIVER, AS_PICAP, AS_SHOPPER)
   * @param {string} bookingId - ID del booking/reserva
   * @returns {Promise<void>}
   */
  sendMessage(message, senderType, bookingId) {
    throw new Error('Method "sendMessage" must be implemented by subclass');
  }

  /**
   * Escucha mensajes nuevos en tiempo real
   * @param {string} bookingId - ID del booking/reserva
   * @param {Function} onChildAdded - Callback que se ejecuta cuando llega un nuevo mensaje
   * @returns {void}
   */
  listenForMessages(bookingId, onChildAdded) {
    throw new Error('Method "listenForMessages" must be implemented by subclass');
  }

  /**
   * Escucha solo el último mensaje
   * @param {string} bookingId - ID del booking/reserva
   * @param {Function} onChildAdded - Callback que se ejecuta cuando llega un nuevo mensaje
   * @returns {void}
   */
  listenLastMessages(bookingId, onChildAdded) {
    throw new Error('Method "listenLastMessages" must be implemented by subclass');
  }

  /**
   * Detiene la escucha de mensajes y limpia recursos
   * @param {string} bookingId - ID del booking/reserva
   * @returns {void}
   */
  disconnect(bookingId) {
    // Método opcional - puede ser implementado por subclases si necesitan cleanup
  }
}

export default ChatAdapter;
